import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ASSETS, TRIBUTE } from "../../data/content";
import Reveal from "./Reveal";

export default function ParentTribute() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const yImg = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0.3, 1, 1, 0.3]);

  return (
    <section
      id="tribute"
      ref={ref}
      data-testid="tribute-section"
      className="relative h-[140vh] md:h-[160vh] overflow-hidden bg-[#050B14]"
    >
      {/* Sticky full-bleed image */}
      <div className="sticky top-0 h-screen w-full overflow-hidden">
        <motion.img
          style={{ y: yImg }}
          src={ASSETS.yacht.bwFullSail}
          alt="MARIE-JOSEPH under full sail at dawn"
          loading="lazy"
          className="absolute inset-0 w-full h-[120%] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050B14]/70 via-[#050B14]/30 to-[#050B14]/70" />
        <div className="absolute inset-0 bg-[#050B14]/30" />

        <motion.div
          style={{ opacity }}
          className="relative z-10 h-full flex items-center justify-center px-6 md:px-12"
        >
          <div className="max-w-3xl text-center">
            <Reveal>
              <div className="flex items-center justify-center gap-4 mb-10">
                <div className="h-px w-10 bg-[#E5D3B3]" />
                <span className="overline">{TRIBUTE.overline}</span>
                <div className="h-px w-10 bg-[#E5D3B3]" />
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <h2
                data-testid="tribute-headline"
                className="font-serif-display text-white text-[clamp(2.25rem,5vw,4.75rem)] leading-[1.05] font-light tracking-[-0.02em] whitespace-pre-line"
              >
                {TRIBUTE.title}
              </h2>
            </Reveal>

            <Reveal delay={0.25}>
              <p className="mt-10 text-[#D4C9A8] text-base md:text-lg font-light leading-relaxed max-w-xl mx-auto">
                {TRIBUTE.body}
              </p>
            </Reveal>

            <Reveal delay={0.4}>
              <figure className="mt-14 max-w-2xl mx-auto">
                <blockquote
                  data-testid="tribute-quote"
                  className="font-serif-display italic text-white text-xl md:text-3xl leading-relaxed font-light"
                >
                  &ldquo;{TRIBUTE.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-6 overline text-[11px] text-white/60">
                  — {TRIBUTE.attribution}
                </figcaption>
              </figure>
            </Reveal>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
